// useValidatedDetailChange.js
export const useValidatedDetailChange = (
  setFormData,
  setErrors
) => {
  return (index, field, validator) => (e) => {
    const raw = e.target.value;
    const { value, error } = validator(raw);

    // エラーだけ更新（即時表示）
    setErrors((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: error };
      return next;
    });

    if (value === null) return;

    setFormData((prev) => {
      const details = [...prev.details];
      details[index] = {
        ...details[index],
        [field]: value,
      };
      return { ...prev, details };
    });
  };
};
